import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface AccountSummaryTooltipProps {
  openLeft: boolean
  isBudget: boolean
  isLimitedBudget: boolean
}

const AccountSummaryTooltip: React.FC<AccountSummaryTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        {!props.isBudget && (
          <Trns
            source={
              "${accountSummary} gives you an overview of how much spending power you've issued and, of that, what has been spent."
            }
            expressions={{
              accountSummary: (
                <span
                  css={css`
                    font-family: ${styleConstants.fontFamilies.medium};
                  `}
                >
                  <Trns source={'Account Summary'} />
                </span>
              ),
            }}
          />
        )}
        {props.isBudget && !props.isLimitedBudget && (
          <Trns
            source={
              '${budgetSummary} gives you an overview of how much spending power has been issued and, of that, what has been spent.'
            }
            expressions={{
              budgetSummary: (
                <span
                  css={css`
                    font-family: ${styleConstants.fontFamilies.medium};
                  `}
                >
                  <Trns source={'Budget Summary'} />
                </span>
              ),
            }}
          />
        )}
        {props.isBudget && props.isLimitedBudget && (
          <Trns
            source={
              '${budgetSummary} gives you an overview of how much spending power has been issued and how much of the budget remains. ${remaining} tells you how much of the budget is left.'
            }
            expressions={{
              budgetSummary: (
                <span
                  css={css`
                    font-family: ${styleConstants.fontFamilies.medium};
                  `}
                >
                  <Trns source={'Budget Summary'} />
                </span>
              ),
              remaining: (
                <span
                  css={css`
                    font-family: ${styleConstants.fontFamilies.medium};
                  `}
                >
                  <Trns source={'Remaining'} />
                </span>
              ),
            }}
          />
        )}
      </p>
      <p
        css={css`
          margin-top: 12px;
        `}
      >
        <Trns
          source={
            '${currentExposure} represents the sum of all available credit across active virtual cards. Any inactive virtual cards will not be reflected in this amount.'
          }
          expressions={{
            currentExposure: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Current Exposure'} />
              </span>
            ),
          }}
        />
      </p>
    </Tooltip>
  )
}

export default AccountSummaryTooltip
